"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.addAirlineToFareFamilyKeys = addAirlineToFareFamilyKeys;
exports.addFareFamilyItemToItinerary = addFareFamilyItemToItinerary;
exports.addScoreToItineraries = addScoreToItineraries;
exports.calculateFareFamilyDifference = calculateFareFamilyDifference;
exports.calculateItineraryScore = calculateItineraryScore;
exports.checkFanIdFlight = checkFanIdFlight;
exports.checkHajjUmrahFlight = checkHajjUmrahFlight;
exports.checkInsuranceOnlyAvailable = checkInsuranceOnlyAvailable;
exports.checkItineraryAirportChange = checkItineraryAirportChange;
exports.checkValidInsuranceDate = checkValidInsuranceDate;
exports.default = void 0;
exports.generateItineraryHashMap = generateItineraryHashMap;
exports.generateItineraryLegHashMap = generateItineraryLegHashMap;
exports.getAmenitiesCodes = getAmenitiesCodes;
exports.getFareFamilyOptions = getFareFamilyOptions;
exports.getFlightInsuranceCoverage = getFlightInsuranceCoverage;
exports.getFlightsCountsWithLimitedSeat = getFlightsCountsWithLimitedSeat;
exports.getInsuranceExpiryDate = getInsuranceExpiryDate;
exports.getItineraryBaggage = getItineraryBaggage;
exports.getItineraryClasses = getItineraryClasses;
exports.getItineraryDuration = getItineraryDuration;
exports.getItineraryLegDetails = getItineraryLegDetails;
exports.getItineraryPrice = getItineraryPrice;
exports.getItineraryScore = getItineraryScore;
exports.getItinerarySeatCount = getItinerarySeatCount;
exports.getPropertyValuesRangeMap = getPropertyValuesRangeMap;
exports.getUpgradeFareExtraAmount = getUpgradeFareExtraAmount;
exports.hasMixedFareFamilies = hasMixedFareFamilies;
exports.isInboundXY = isInboundXY;
exports.shouldIncludeItinerary = shouldIncludeItinerary;
exports.transferFareFamilies = transferFareFamilies;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _min2 = _interopRequireDefault(require("lodash/min"));
var _reduce2 = _interopRequireDefault(require("lodash/reduce"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _head2 = _interopRequireDefault(require("lodash/head"));
var _indexOf2 = _interopRequireDefault(require("lodash/indexOf"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _is_within_range = _interopRequireDefault(require("date-fns/is_within_range"));
var _baggage = _interopRequireDefault(require("../factories/baggage.factory"));
var _itinerary = _interopRequireDefault(require("../factories/itinerary.factory"));
var _fareFamilyItinerary = require("../factories/fare-family-itinerary.factory");
var _constants = require("../constants");
var _itineraryForAgent = _interopRequireDefault(require("../factories/itinerary-for-agent.factory"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _mapKeys2 = _interopRequireDefault(require("lodash/mapKeys"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function generateItineraryHashMap(_ref) {
  var itineraries = _ref.itineraries,
    legHashMap = _ref.legHashMap,
    searchRequest = _ref.searchRequest,
    vendor = _ref.vendor,
    $currency = _ref.$currency,
    config = _ref.config;
  var hashMap = {};
  var flightPathMap = {};
  var showAgentResults = config.showAgentResults;
  var isFlexibleDate = (searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.flexibleDate) === _constants.SEARCH_BOX_CONSTANTS.FLEX_1D;
  (0, _each2.default)(itineraries, function (itinerary) {
    var itineraryFactoryParams = {
      itinerary: itinerary,
      legHashMap: legHashMap,
      searchRequest: searchRequest,
      vendor: vendor,
      $currency: $currency
    };
    var currentItinerary = showAgentResults ? (0, _itineraryForAgent.default)(itineraryFactoryParams) : (0, _itinerary.default)(itineraryFactoryParams);
    if (currentItinerary.hasMixedFareFamilies) return;
    var _shouldIncludeItinera = shouldIncludeItinerary({
        itinerary: itinerary,
        flightPathMap: flightPathMap,
        departureDate: isFlexibleDate && currentItinerary.firstLegDepartureTime
      }),
      nextFlightPathMap = _shouldIncludeItinera.nextFlightPathMap,
      shouldInclude = _shouldIncludeItinera.shouldInclude,
      expiredId = _shouldIncludeItinera.expiredId,
      flightPath = _shouldIncludeItinera.flightPath;
    flightPathMap = nextFlightPathMap;
    hashMap[currentItinerary.id] = currentItinerary;
    var expiredItinerary = hashMap[String(expiredId)];
    if (isInboundXY(currentItinerary)) {
      hashMap[currentItinerary.id] = currentItinerary;
      return;
    }
    if (shouldInclude && expiredItinerary) {
      expiredItinerary.isExcluded = true;
      hashMap[currentItinerary.id] = transferFareFamilies(expiredItinerary, currentItinerary);
      return;
    }
    if (!shouldInclude) {
      var _flightPathMap, _flightPathMap$String;
      var previousItineraryId = (_flightPathMap = flightPathMap) === null || _flightPathMap === void 0 ? void 0 : (_flightPathMap$String = _flightPathMap[String(flightPath)]) === null || _flightPathMap$String === void 0 ? void 0 : _flightPathMap$String.id;
      currentItinerary.isExcluded = true;
      var fareFamilyItem = (0, _fareFamilyItinerary.fareFamilyItineraryFactory)(currentItinerary);
      hashMap[previousItineraryId] = addFareFamilyItemToItinerary(hashMap[previousItineraryId], fareFamilyItem);
    }
  });
  return hashMap;
}
function addFareFamilyItemToItinerary(itinerary, item) {
  var _itinerary$fareFamili;
  var fareFamilies = (_itinerary$fareFamili = itinerary === null || itinerary === void 0 ? void 0 : itinerary.fareFamilies) !== null && _itinerary$fareFamili !== void 0 ? _itinerary$fareFamili : [(0, _fareFamilyItinerary.fareFamilyItineraryFactory)(itinerary)];
  fareFamilies.push(item);
  var sortField = getFareFamilySortField(item);
  return _objectSpread(_objectSpread({}, itinerary), {}, {
    fareFamilies: (0, _sortBy2.default)(fareFamilies, sortField)
  });
}
function transferFareFamilies(fromItinerary, toItinerary) {
  var _fromItinerary$fareFa;
  if (!fromItinerary) return toItinerary;
  var fareFamilies = (_fromItinerary$fareFa = fromItinerary === null || fromItinerary === void 0 ? void 0 : fromItinerary.fareFamilies) !== null && _fromItinerary$fareFa !== void 0 ? _fromItinerary$fareFa : [(0, _fareFamilyItinerary.fareFamilyItineraryFactory)(fromItinerary)];
  var toFareFamily = (0, _fareFamilyItinerary.fareFamilyItineraryFactory)(toItinerary);
  fareFamilies.push(toFareFamily);
  var sortField = getFareFamilySortField(toFareFamily);
  return _objectSpread(_objectSpread({}, toItinerary), {}, {
    fareFamilies: (0, _sortBy2.default)(fareFamilies, sortField)
  });
}
function getFareFamilySortField(fareFamily) {
  return !fareFamily.cheapestRoundtripTotal ? "totalPrice" : "cheapestRoundtripTotal";
}
function calculateFareFamilyDifference(fareFamilies, currency) {
  return (0, _map2.default)(fareFamilies, function (fareFamily, index) {
    var currentFareFamily = _objectSpread({}, fareFamily);
    if (index > 0) {
      var previousFare = fareFamilies[index - 1];
      currentFareFamily.displayPrice.fareFamilyDifference = currency.formatPriceWithDecimals(currency.convertPrice(currentFareFamily.totalPrice - previousFare.totalPrice), 0);
    } else {
      currentFareFamily.displayPrice.fareFamilyDifference = "0";
    }
    return currentFareFamily;
  });
}
function generateItineraryLegHashMap(itineraries) {
  return (0, _keyBy2.default)(itineraries, function (itinerary) {
    return (0, _join2.default)(itinerary.legId, _constants.LEG_IDS_SEPARATOR);
  });
}
function shouldIncludeItinerary(_ref2) {
  var _itinerary$price$tota, _itinerary$price, _itinerary$price$tota2;
  var itinerary = _ref2.itinerary,
    flightPathMap = _ref2.flightPathMap,
    departureDate = _ref2.departureDate;
  var flightPath = (0, _join2.default)(!departureDate ? itinerary === null || itinerary === void 0 ? void 0 : itinerary.path : [].concat(itinerary === null || itinerary === void 0 ? void 0 : itinerary.path, [departureDate]), ":");
  var nextFlightPathMap = _objectSpread({}, flightPathMap);
  var occupiedItineraryInfo = flightPathMap === null || flightPathMap === void 0 ? void 0 : flightPathMap[flightPath];
  var shouldInclude = true;
  if (!flightPath || _constants.OPEN_TICKETING_TYPES.includes(itinerary === null || itinerary === void 0 ? void 0 : itinerary.ticketScenario)) return {
    shouldInclude: shouldInclude,
    nextFlightPathMap: nextFlightPathMap
  };
  var itineraryPrice = (_itinerary$price$tota = itinerary === null || itinerary === void 0 ? void 0 : (_itinerary$price = itinerary.price) === null || _itinerary$price === void 0 ? void 0 : (_itinerary$price$tota2 = _itinerary$price.totals) === null || _itinerary$price$tota2 === void 0 ? void 0 : _itinerary$price$tota2.total) !== null && _itinerary$price$tota !== void 0 ? _itinerary$price$tota : 0;
  var haveHigherPriority = itineraryPrice < (occupiedItineraryInfo === null || occupiedItineraryInfo === void 0 ? void 0 : occupiedItineraryInfo.price);
  shouldInclude = haveHigherPriority || !occupiedItineraryInfo;
  if (shouldInclude) {
    nextFlightPathMap[flightPath] = {
      id: itinerary.id,
      price: itineraryPrice
    };
  }
  return {
    shouldInclude: shouldInclude,
    nextFlightPathMap: nextFlightPathMap,
    expiredId: occupiedItineraryInfo === null || occupiedItineraryInfo === void 0 ? void 0 : occupiedItineraryInfo.id,
    flightPath: flightPath
  };
}
function getItineraryLegDetails(legDetails) {
  return (0, _map2.default)(legDetails, function (leg, index) {
    var _leg$index;
    var segment = (0, _map2.default)(leg === null || leg === void 0 ? void 0 : leg.segment, function (segment) {
      return getItinerarySegmentDetails(segment);
    });
    var seatsAvailablePerSegment = (0, _map2.default)(segment, function (item) {
      var availability = item.availability ? +item.availability : undefined;
      return (0, _isNumber2.default)(availability) ? availability : undefined;
    });
    var isSeatsDefined = (0, _some2.default)(seatsAvailablePerSegment, function (seat) {
      return (0, _isNumber2.default)(seat);
    });
    var seatsAvailable = isSeatsDefined ? (0, _min2.default)(seatsAvailablePerSegment) : undefined;
    return {
      index: (_leg$index = leg === null || leg === void 0 ? void 0 : leg.index) !== null && _leg$index !== void 0 ? _leg$index : index + 1,
      segment: segment,
      seatsAvailable: seatsAvailable
    };
  });
}
function getItinerarySegmentDetails(segment) {
  var _segment$classOfLeg, _segment$cabinCode, _segment$cabinText, _segment$availability, _segment$fareBasis;
  return {
    classOfLeg: (_segment$classOfLeg = segment === null || segment === void 0 ? void 0 : segment.classOfLeg) !== null && _segment$classOfLeg !== void 0 ? _segment$classOfLeg : "",
    cabinCode: (_segment$cabinCode = segment === null || segment === void 0 ? void 0 : segment.cabinCode) !== null && _segment$cabinCode !== void 0 ? _segment$cabinCode : "",
    cabinText: (_segment$cabinText = segment === null || segment === void 0 ? void 0 : segment.cabinText) !== null && _segment$cabinText !== void 0 ? _segment$cabinText : "",
    availability: (_segment$availability = segment === null || segment === void 0 ? void 0 : segment.availability) !== null && _segment$availability !== void 0 ? _segment$availability : "",
    mealService: segment === null || segment === void 0 ? void 0 : segment.mealService,
    fareBasis: (_segment$fareBasis = segment === null || segment === void 0 ? void 0 : segment.fareBasis) !== null && _segment$fareBasis !== void 0 ? _segment$fareBasis : "",
    freeBaggage: getItinerarySegmentBaggage(segment)
  };
}
function getItinerarySegmentBaggage(segment) {
  var _segment$freeBaggage, _segment$freeBaggage2, _segment$freeBaggage3, _segment$freeBaggage4;
  return {
    cabin: (0, _baggage.default)(segment === null || segment === void 0 ? void 0 : (_segment$freeBaggage = segment.freeBaggage) === null || _segment$freeBaggage === void 0 ? void 0 : _segment$freeBaggage.cabin),
    checkIn: (0, _baggage.default)(segment === null || segment === void 0 ? void 0 : (_segment$freeBaggage2 = segment.freeBaggage) === null || _segment$freeBaggage2 === void 0 ? void 0 : _segment$freeBaggage2.checkIn),
    underSeatBaggage: (0, _baggage.default)(segment === null || segment === void 0 ? void 0 : (_segment$freeBaggage3 = segment.freeBaggage) === null || _segment$freeBaggage3 === void 0 ? void 0 : _segment$freeBaggage3.underSeat),
    baggageOptionsAvailable: segment === null || segment === void 0 ? void 0 : (_segment$freeBaggage4 = segment.freeBaggage) === null || _segment$freeBaggage4 === void 0 ? void 0 : _segment$freeBaggage4.baggageOptionsAvailable
  };
}
function getItineraryPrice(price, convertPrice, priceRules) {
  var _price$totals, _totals$oldTotal, _totals$oldCheapestRo, _totals$cheapestRound, _totals$oldRoundtripT, _totals$roundtripTota, _totals$tax, _totals$base, _totals$couponDiscoun, _totals$baggage, _totals$mu, _totals$penalty;
  var serviceFee = priceRules.filter(function (rule) {
    return rule.operation.toUpperCase() === "ADD" && _constants.SERVICE_FEE_RULES_PATTERNS.some(function (regex) {
      return regex.test(rule.code);
    });
  }).reduce(function (prev, curr) {
    return prev + (curr === null || curr === void 0 ? void 0 : curr.discountAmount) || 0;
  }, 0);
  var totals = (_price$totals = price === null || price === void 0 ? void 0 : price.totals) !== null && _price$totals !== void 0 ? _price$totals : {};
  var total = (totals === null || totals === void 0 ? void 0 : totals.total) - serviceFee;
  var oldTotal = (_totals$oldTotal = totals === null || totals === void 0 ? void 0 : totals.oldTotal) !== null && _totals$oldTotal !== void 0 ? _totals$oldTotal : 0;
  var hasOutboundDiscount = (0, _floor2.default)((_totals$oldCheapestRo = totals === null || totals === void 0 ? void 0 : totals.oldCheapestRoundtripTotal) !== null && _totals$oldCheapestRo !== void 0 ? _totals$oldCheapestRo : 0) > (0, _floor2.default)((_totals$cheapestRound = totals === null || totals === void 0 ? void 0 : totals.cheapestRoundtripTotal) !== null && _totals$cheapestRound !== void 0 ? _totals$cheapestRound : 0);
  var hasInboundDiscount = (0, _floor2.default)((_totals$oldRoundtripT = totals === null || totals === void 0 ? void 0 : totals.oldRoundtripTotal) !== null && _totals$oldRoundtripT !== void 0 ? _totals$oldRoundtripT : 0) > (0, _floor2.default)((_totals$roundtripTota = totals === null || totals === void 0 ? void 0 : totals.roundtripTotal) !== null && _totals$roundtripTota !== void 0 ? _totals$roundtripTota : 0);
  return {
    total: convertPrice(total),
    oldTotal: convertPrice(oldTotal),
    tax: convertPrice((_totals$tax = totals === null || totals === void 0 ? void 0 : totals.tax) !== null && _totals$tax !== void 0 ? _totals$tax : 0),
    base: convertPrice((_totals$base = totals === null || totals === void 0 ? void 0 : totals.base) !== null && _totals$base !== void 0 ? _totals$base : 0),
    couponDiscount: convertPrice((_totals$couponDiscoun = totals === null || totals === void 0 ? void 0 : totals.couponDiscount) !== null && _totals$couponDiscoun !== void 0 ? _totals$couponDiscoun : 0),
    baggage: convertPrice((_totals$baggage = totals === null || totals === void 0 ? void 0 : totals.baggage) !== null && _totals$baggage !== void 0 ? _totals$baggage : 0),
    mu: convertPrice((_totals$mu = totals === null || totals === void 0 ? void 0 : totals.mu) !== null && _totals$mu !== void 0 ? _totals$mu : 0),
    penalty: convertPrice((_totals$penalty = totals === null || totals === void 0 ? void 0 : totals.penalty) !== null && _totals$penalty !== void 0 ? _totals$penalty : 0),
    hasDiscount: (0, _floor2.default)(oldTotal) > (0, _floor2.default)(total),
    fee: convertPrice(serviceFee),
    cheapestInboundFare: convertPrice(totals.cheapestInboundFare),
    cheapestRoundtripTotal: convertPrice(totals.cheapestRoundtripTotal),
    roundtripTotalDiff: convertPrice(totals === null || totals === void 0 ? void 0 : totals.roundtripTotalDiff),
    fareFamilyDifference: convertPrice(totals === null || totals === void 0 ? void 0 : totals.fareFamilyDifference),
    fareFamilyRoundtripDifference: convertPrice(totals === null || totals === void 0 ? void 0 : totals.fareFamilyRoundtripDifference),
    oldCheapestRoundtripTotal: convertPrice(totals === null || totals === void 0 ? void 0 : totals.oldCheapestRoundtripTotal),
    roundtripTotal: convertPrice(totals === null || totals === void 0 ? void 0 : totals.roundtripTotal),
    oldRoundtripTotal: convertPrice(totals === null || totals === void 0 ? void 0 : totals.oldRoundtripTotal),
    hasOutboundDiscount: hasOutboundDiscount,
    hasInboundDiscount: hasInboundDiscount
  };
}
function getItineraryBaggage(legs) {
  return (0, _map2.default)(legs, function (leg) {
    var _leg$validatingCarrie, _lastSegment$addition, _lastSegment$addition2, _freeBaggage$checkIn, _leg$originId, _leg$destinationId;
    var segments = leg === null || leg === void 0 ? void 0 : leg.segments;
    var lastSegment = (0, _head2.default)(segments);
    var carrier = (_leg$validatingCarrie = leg === null || leg === void 0 ? void 0 : leg.validatingCarrier) !== null && _leg$validatingCarrie !== void 0 ? _leg$validatingCarrie : "";
    var baggage = (_lastSegment$addition = lastSegment === null || lastSegment === void 0 ? void 0 : (_lastSegment$addition2 = lastSegment.additionalDetails) === null || _lastSegment$addition2 === void 0 ? void 0 : _lastSegment$addition2.freeBaggage) !== null && _lastSegment$addition !== void 0 ? _lastSegment$addition : {
      cabin: null,
      checkIn: null,
      underSeatBaggage: null,
      baggageOptionsAvailable: false
    };
    var freeBaggage = {
      cabin: (0, _baggage.default)(baggage === null || baggage === void 0 ? void 0 : baggage.cabin),
      checkIn: (0, _baggage.default)(baggage === null || baggage === void 0 ? void 0 : baggage.checkIn),
      underSeatBaggage: (0, _baggage.default)(baggage === null || baggage === void 0 ? void 0 : baggage.underSeatBaggage),
      baggageOptionsAvailable: baggage === null || baggage === void 0 ? void 0 : baggage.baggageOptionsAvailable
    };
    var weight = freeBaggage === null || freeBaggage === void 0 ? void 0 : (_freeBaggage$checkIn = freeBaggage.checkIn) === null || _freeBaggage$checkIn === void 0 ? void 0 : _freeBaggage$checkIn.totalWeight;
    var baggagePerSegment = (0, _map2.default)(segments, "additionalDetails.freeBaggage");
    return {
      legId: leg === null || leg === void 0 ? void 0 : leg.id,
      freeBaggage: freeBaggage,
      originId: (_leg$originId = leg === null || leg === void 0 ? void 0 : leg.originId) !== null && _leg$originId !== void 0 ? _leg$originId : "",
      destinationId: (_leg$destinationId = leg === null || leg === void 0 ? void 0 : leg.destinationId) !== null && _leg$destinationId !== void 0 ? _leg$destinationId : "",
      carrier: carrier,
      hasBaggageOffer: weight ? weight > 30 : false,
      freeBaggagePerSegment: baggagePerSegment
    };
  });
}
function getItineraryClasses(legDetails) {
  var classes = [];
  (0, _each2.default)(legDetails, function (leg) {
    (0, _each2.default)(leg === null || leg === void 0 ? void 0 : leg.segment, function (_ref3) {
      var cabinText = _ref3.cabinText;
      var cabin = (0, _capitalize2.default)(cabinText);
      !classes.includes(cabin) && classes.push(cabin);
    });
  });
  return (0, _compact2.default)(classes);
}
function getAmenitiesCodes(legs) {
  var amenitiesCodes = [];
  (0, _each2.default)(legs, function (leg) {
    (0, _each2.default)(leg === null || leg === void 0 ? void 0 : leg.segments, function (_ref4) {
      var amenitiesCode = _ref4.amenitiesCode;
      !amenitiesCodes.includes(amenitiesCode) && amenitiesCodes.push(amenitiesCode);
    });
  });
  return (0, _compact2.default)(amenitiesCodes);
}
function getItinerarySeatCount(legDetails) {
  var seatCount = [];
  (0, _each2.default)(legDetails, function (leg) {
    (0, _each2.default)(leg === null || leg === void 0 ? void 0 : leg.segment, function (segment) {
      var availableSeatCount = Number(segment === null || segment === void 0 ? void 0 : segment.availability);
      if (availableSeatCount <= _constants.MAX_SEAT_COUNT) {
        seatCount.push(availableSeatCount);
      }
    });
  });
  return Number((0, _min2.default)(seatCount));
}
function getFlightsCountsWithLimitedSeat(itineraries, maxSeatCount) {
  return (0, _filter2.default)(itineraries, function (itinerary) {
    return itinerary.seatCount <= maxSeatCount;
  }).length;
}
function getItineraryDuration(legs) {
  return (0, _reduce2.default)(legs, function (itineraryDuration, leg) {
    return itineraryDuration + (leg === null || leg === void 0 ? void 0 : leg.durationInSeconds);
  }, 0);
}
function getPropertyValuesRangeMap(itineraries, propertyKeys) {
  var rangeMap = {};
  (0, _each2.default)(propertyKeys, function (propertyKey) {
    var propertyValues = (0, _map2.default)(itineraries, propertyKey);
    var min = Math.min.apply(Math, propertyValues);
    var max = Math.max.apply(Math, propertyValues);
    rangeMap[propertyKey] = {
      min: min,
      max: max
    };
  });
  return rangeMap;
}
function getItineraryScore(_ref5) {
  var itinerary = _ref5.itinerary,
    bestFlights = _ref5.bestFlights;
  var maxScore = (0, _size2.default)(bestFlights);
  var itineraryId = itinerary === null || itinerary === void 0 ? void 0 : itinerary.id;
  var score = (0, _indexOf2.default)(bestFlights, itineraryId);
  if (score === -1) {
    return maxScore + 1;
  }
  return score;
}
function calculateItineraryScore(_ref6) {
  var itinerary = _ref6.itinerary,
    propertyValuesRangeMap = _ref6.propertyValuesRangeMap,
    propertyWeightMap = _ref6.propertyWeightMap;
  var score = 0;
  (0, _each2.default)(propertyWeightMap, function (propertyWeight, propertyKey) {
    var _propertyValuesRangeM = propertyValuesRangeMap[propertyKey],
      min = _propertyValuesRangeM.min,
      max = _propertyValuesRangeM.max;
    var propertyValue = Number(itinerary === null || itinerary === void 0 ? void 0 : itinerary[propertyKey]);
    if (min !== max) {
      score += (propertyValue - min) / (max - min) * propertyWeight;
    }
  });
  return score;
}
function addScoreToItineraries(_ref7) {
  var itineraries = _ref7.itineraries,
    allFilters = _ref7.allFilters;
  return (0, _map2.default)(itineraries, function (itinerary) {
    itinerary.bestScore = getItineraryScore({
      itinerary: itinerary,
      bestFlights: allFilters.bestFlights
    });
    itinerary.cheapestScore = getItineraryScore({
      itinerary: itinerary,
      bestFlights: allFilters.cheapestFlights
    });
    itinerary.shortestScore = getItineraryScore({
      itinerary: itinerary,
      bestFlights: allFilters.shortestFlights
    });
    return itinerary;
  });
}
function getFlightInsuranceCoverage(legs) {
  return (0, _every2.default)((0, _map2.default)(legs, function (leg) {
    return (0, _includes2.default)(_constants.AIRLINES_WITH_COVERAGE, leg.validatingCarrier);
  }));
}
function getInsuranceExpiryDate(carrier) {
  return carrier === "WY" ? new Date("03/31/2021") : new Date("12/31/2020");
}
function checkValidInsuranceDate() {
  return (0, _is_before.default)(new Date(), new Date("01/01/2021"));
}
function checkInsuranceOnlyAvailable(flightFilterParams) {
  return (0, _some2.default)(flightFilterParams, {
    insuranceOnly: true
  });
}
function checkFanIdFlight(departureDate, destinationId) {
  var toQatar = _constants.WORLD_CUP_FAN_ID.AIRPORTS.includes(destinationId);
  var isInRange = (0, _is_within_range.default)(departureDate, _constants.WORLD_CUP_FAN_ID.RANGE[0], _constants.WORLD_CUP_FAN_ID.RANGE[1]);
  return toQatar && isInRange;
}
function checkHajjUmrahFlight(flightCodes, destinationId) {
  if (_constants.HAJJ_UMRAH_AIRPORTS.includes(destinationId)) {
    return (0, _reduce2.default)(flightCodes, function (isHajjUmrahFlight, flightCode) {
      return isHajjUmrahFlight || _constants.HAJJ_UMRAH_FLIGHTS.includes(flightCode);
    }, false);
  }
  return false;
}
function hasMixedFareFamilies(legs, isRoundTrip) {
  var _legs$, _legs$2;
  return isRoundTrip && (0, _size2.default)(legs) === 2 && (legs === null || legs === void 0 ? void 0 : (_legs$ = legs[0]) === null || _legs$ === void 0 ? void 0 : _legs$.fareFamily) !== (legs === null || legs === void 0 ? void 0 : (_legs$2 = legs[1]) === null || _legs$2 === void 0 ? void 0 : _legs$2.fareFamily);
}
function getFareFamilyOptions(_ref8) {
  var fareItineraries = _ref8.fareItineraries,
    itineraryId = _ref8.itineraryId,
    isRoundTrip = _ref8.isRoundTrip,
    $currency = _ref8.$currency;
  var fareFamilies = isRoundTrip ? (0, _filter2.default)(fareItineraries, "isSameFareFamily") : fareItineraries;
  fareFamilies = (0, _sortBy2.default)(fareFamilies, "price");
  if ((0, _size2.default)(fareFamilies) < 2) {
    return [];
  }
  var selectedFareIndex = (0, _findIndex2.default)(fareFamilies, ["id", itineraryId]);
  if (selectedFareIndex === -1) {
    return [];
  }
  return (0, _map2.default)(fareFamilies, function (fareOption) {
    var _fareOption$fareFamil;
    return _objectSpread(_objectSpread({}, fareOption), {}, {
      code: fareOption === null || fareOption === void 0 ? void 0 : (_fareOption$fareFamil = fareOption.fareFamily) === null || _fareOption$fareFamil === void 0 ? void 0 : _fareOption$fareFamil[0],
      totalPrice: $currency.formatPriceWithDecimals(fareOption === null || fareOption === void 0 ? void 0 : fareOption.price, 0),
      displayPrice: {
        currency: fareOption.currency,
        total: $currency.formatPriceWithDecimals(fareOption === null || fareOption === void 0 ? void 0 : fareOption.price, 0)
      }
    });
  });
}
function getUpgradeFareExtraAmount(fareFamilyOption, $currency) {
  var _fareFamilyOption$0$p, _fareFamilyOption$, _fareFamilyOption$1$p, _fareFamilyOption$2;
  var selectedFareFamily = (_fareFamilyOption$0$p = fareFamilyOption === null || fareFamilyOption === void 0 ? void 0 : (_fareFamilyOption$ = fareFamilyOption[0]) === null || _fareFamilyOption$ === void 0 ? void 0 : _fareFamilyOption$.price) !== null && _fareFamilyOption$0$p !== void 0 ? _fareFamilyOption$0$p : 0;
  var upgradedFareFamily = (_fareFamilyOption$1$p = fareFamilyOption === null || fareFamilyOption === void 0 ? void 0 : (_fareFamilyOption$2 = fareFamilyOption[1]) === null || _fareFamilyOption$2 === void 0 ? void 0 : _fareFamilyOption$2.price) !== null && _fareFamilyOption$1$p !== void 0 ? _fareFamilyOption$1$p : 0;
  var extraAmount = upgradedFareFamily - selectedFareFamily;
  return $currency.currentCurrency + " " + $currency.formatPriceWithDecimals(extraAmount, 0);
}
function isInboundXY(itinerary) {
  return itinerary.validatingCarrier === _constants.FLYNAS_CODE && itinerary.direction === _constants.INBOUND && (0, _includes2.default)(_constants.VENDORS.TF_CODES, itinerary.vendor);
}
function addAirlineToFareFamilyKeys(data) {
  return _objectSpread(_objectSpread({}, data), {}, {
    res: (0, _map2.default)(data.res, function (result) {
      var _result$data;
      var _brandedFares = {};
      if (result.status === 200 && !(0, _isEmpty2.default)(result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.brandedFares)) {
        var _result$data2 = result === null || result === void 0 ? void 0 : result.data,
          brandedFares = _result$data2.brandedFares,
          airline = _result$data2.airline;
        (0, _mapKeys2.default)(brandedFares, function (fare, key) {
          _brandedFares[airline[0] + "_" + key] = brandedFares[key];
        });
      }
      return _objectSpread(_objectSpread({}, result), {}, {
        data: _objectSpread(_objectSpread({}, result.data), (0, _isEmpty2.default)(_brandedFares) ? {} : {
          brandedFares: _brandedFares
        })
      });
    })
  });
}
function checkItineraryAirportChange(legs) {
  var airportChange = (0, _map2.default)(legs, function (leg) {
    return leg === null || leg === void 0 ? void 0 : leg.hasChangeAirportFlag;
  });
  return (0, _includes2.default)(airportChange, true);
}
var _default = exports.default = {
  getItineraryLegDetails: getItineraryLegDetails,
  getItineraryBaggage: getItineraryBaggage,
  getItineraryPrice: getItineraryPrice,
  getItineraryClasses: getItineraryClasses,
  getAmenitiesCodes: getAmenitiesCodes,
  getItinerarySeatCount: getItinerarySeatCount,
  getFlightsCountsWithLimitedSeat: getFlightsCountsWithLimitedSeat,
  getItineraryDuration: getItineraryDuration,
  getFlightInsuranceCoverage: getFlightInsuranceCoverage,
  getInsuranceExpiryDate: getInsuranceExpiryDate,
  checkValidInsuranceDate: checkValidInsuranceDate,
  checkInsuranceOnlyAvailable: checkInsuranceOnlyAvailable,
  checkHajjUmrahFlight: checkHajjUmrahFlight,
  checkFanIdFlight: checkFanIdFlight,
  addAirlineToFareFamilyKeys: addAirlineToFareFamilyKeys
};